import React from 'react';
import { propertyBlock, property } from './PropertyStarter.module.css';
import ImgLoader from '../ImgLoader/ImgLoader';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const PropertySelectionBox = ({ propertyStatus, src, hanldeClick,text }) => {
  return (
    <div className="table mx-auto pt-1">
      <div className="flex  mx-auto">
        <div
          className={`${propertyBlock}  mx-auto cursor-pointer border ${
            propertyStatus ? 'border-green-1000' : 'border-blue-100'
          } rounded`}
          onClick={hanldeClick}
        >
          <ImgLoader
            src={src}
            Classnames={property}
            loaderContainerStyle={{ minHeight: '85px' }}
            loaderContainerClass="pt-8"
          />
          <p className="text-black-500 text-xs text-center font-roboto mt-1">
            {text}
          </p>
        </div>
        <CheckCircleIcon
          className={`-ml-3 -mt-2 text-green-1000 z-50 ${!propertyStatus &&
            'invisible'}`}
        />
      </div>
    </div>
  );
};

export default PropertySelectionBox;
